import * as React from "react";
import useMediaQuery from "../../hooks/useMediaQuery";
import QueryContext from ".";
const QueryContextProvider = ({
  children
}) => {
  const value = useMediaQuery();
  return /*#__PURE__*/React.createElement(QueryContext.Provider, {
    value: value
  }, children);
};
export default QueryContextProvider;